import React from 'react'
import { navigate } from "@reach/router";
import Chip from './chip';


const TagChip = ({tag}) => {
  return (
    <Chip label={tag} onClick={() => navigate('/etiqueta/' + tag )} />
  );
};

export default TagChip